import { apiClient } from "../apiClient";

export const DOT_TUYEN_SINH_ENDPOINT = "dot-tuyen-sinh";
export const dotTuyenSinhApi = {
  SelectByNam: (nam: number) =>
    apiClient.get(`${DOT_TUYEN_SINH_ENDPOINT}/select-by-nam/${nam}`),
};
